import {
  Component,
  Input,
  OnChanges,
  SimpleChanges
} from '@angular/core';

import {
  HaynesProVesaLinkedStoryGroupModel,
  HaynesProVesaLinkedStoryModel
} from '../typings/haynes-pro.vesa-advanced';

@Component({
  selector   : 'wor-haynes-pro-diagnostic-tool-vesa-component-info',
  styles: [ require('./haynes-pro.diagnostic-tool.vesa-component-info.component.scss') ],
  template: require('./haynes-pro.diagnostic-tool.vesa-component-info.component.html')
})
export class HaynesProDiagnosticToolVesaComponentInfoComponent implements OnChanges {

  @Input() linkedStoryGroups : Array<HaynesProVesaLinkedStoryGroupModel> = [];

  selectedGroup     : HaynesProVesaLinkedStoryGroupModel = null;
  selectedStory     : HaynesProVesaLinkedStoryModel      = null;
  selectedStoryName                                      = '';
  storyManuals      : Array<{ name : string; sub_story_lines : Array<any> }> = [];

  ngOnChanges ( changes : SimpleChanges ) : void {
    if (changes.linkedStoryGroups && this.linkedStoryGroups?.length) {
      const firstGroup = this.linkedStoryGroups[0];
      const firstStory = firstGroup?.stories?.[0];

      this.selectedGroup = firstGroup;

      if (firstStory) {
        this.selectStory(firstGroup, firstStory);
      }
    }
  }

  hasContent ( story : HaynesProVesaLinkedStoryModel ) : boolean {
    if (!story) {
      return false;
    }

    return !!(
      story.sub_story_lines?.length
      || story.paragraph_content?.length
      || story.smart_links?.length
      || story.special_tools?.length
      || this.hasTableContent(story.table_content)
    );
  }

  isStorySelected ( group : HaynesProVesaLinkedStoryGroupModel, story : HaynesProVesaLinkedStoryModel ) : boolean {
    return this.selectedGroup === group && this.selectedStoryName === story?.name;
  }

  selectStory ( group : HaynesProVesaLinkedStoryGroupModel, story : HaynesProVesaLinkedStoryModel ) : void {
    this.selectedGroup     = group;
    this.selectedStory     = story;
    this.selectedStoryName = story?.name || '';
    this.storyManuals      = this.buildStoryManuals(story);
  }

  trackByGroup ( _index : number, group : HaynesProVesaLinkedStoryGroupModel ) : string {
    return group?.category_id;
  }

  trackByStory ( _index : number, story : HaynesProVesaLinkedStoryModel ) : string {
    return story?.name;
  }

  // repair-details expects `RepairGroup[]` with `{ name, sub_story_lines }`.
  private buildStoryManuals ( story : HaynesProVesaLinkedStoryModel ) : Array<{ name : string; sub_story_lines : Array<any> }> {
    if (!story) {
      return [];
    }

    return [
      {
        name            : '',
        sub_story_lines : story.sub_story_lines || []
      }
    ];
  }

  private hasTableContent ( tables : Array<any> ) : boolean {
    if (!tables?.length) {
      return false;
    }

    return tables.some(t => Number(t?.rows) > 0 && Number(t?.columns) > 0);
  }
}
